import { useEffect } from 'react';
import { useAuthStore } from '@/store/authStore';
import { useAuthTokens } from '@/utils/tokenHelper';
import { useUserStore } from '@/store/userStore';
import { useSearchStore } from '@/store/searchStore';
import { useRouter } from 'next/router';

const AutoLogout = () => {
  const clearTokens = useAuthStore(state => state.clearTokens);
  const clearUserProfile = useUserStore(state => state.clearUserProfile);
  const resetSearchCount = useSearchStore(state => state.resetSearchCount);

  const { accessToken, refreshToken } = useAuthTokens();

  const router = useRouter();

  useEffect(() => {
    if (accessToken && refreshToken) {
      const autoLogoutTime =
        Number(process.env.NEXT_PUBLIC_AUTO_LOGOUT_TIME) || 30 * 60 * 1000; // Default 30 minutes

      console.log(`Auto logout set for ${autoLogoutTime}ms`);

      const logoutTimer = setTimeout(() => {
        clearTokens();
        clearUserProfile();
        resetSearchCount();
        router.push('/login');
      }, autoLogoutTime);

      return () => clearTimeout(logoutTimer); // Clear the timer if tokens change or component unmounts
    }
  }, [
    accessToken,
    refreshToken,
    clearTokens,
    clearUserProfile,
    resetSearchCount,
    router,
  ]);

  return null; // This is a background component
};

export default AutoLogout;
